<template>
  <div class="aidtools_wrapper">
    <v-header :status="true" />
    <img
      class="toShop"
      @click="
        goUrl(
          'https://detail.tmall.com/item.htm?id=656222056900&rn=4e0235601662cc558b2fb6f2c83086bf&spm=a1z10.3-b-s.w4011-24249604535.30.62275720YpUpyj',
          'outer'
        )
      "
      src="../assets/img2/t1_2x.jpg"
    />
    <div class="introduce-box">
      <img src="../assets/img2/aidtools_introduce.png" />
    </div>
    <div class="history-box">
      <img src="../assets/img2/aidtools_history.png" />
    </div>
    <div class="produce-txt-layout">
      <img src="../assets/img2/aidtools_produce_txt.png" />
    </div>
    <div class="product-box">
      <img id="S3Pro" @click="goWeb(4)" src="../assets/img2/aidtools_s3.png" />
      <img id="S2Pro" @click="goWeb(4)" src="../assets/img2/aidtools_s2.png" />
      <img id="normal" @click="goWeb(0)" src="../assets/img2/aidtools_6.png" />
      <img id="pro" @click="goWeb(1)" src="../assets/img2/aidtools_8.png" />
      <img id="pro2" @click="goWeb(2)" src="../assets/img2/aidtools_10.png" />
      <img
        id="guchebao"
        @click="goWeb(3)"
        src="../assets/img2/aidtools_guchebao.png"
      />
      <img src="../assets/img2/aidtools_function.png" class="padding-top-80" />
    </div>
    <div class="menu-box" id="menu-box">
      <div
        style="position: relative;cursor: pointer;"
        v-for="item in 15"
        @mouseenter="mouseover(item)"
        @mouseleave="selectIndex = -1"
        :key="item"
      >
        <img
          :src="require('../assets/img2/home_menu_' + item + '_default.png')"
        />
        <div v-if="selectIndex == item" class="menu-pop-box">
          {{ list[item - 1] }}
        </div>
      </div>
    </div>
    <div class="video-box">
      <div class="flex-layout" style="justify-content: center">
        <img
          @click="goBack"
          src="../assets/img2/video_arrow_left.png"
          style="cursor: pointer;"
        />
        <div class="vedio-box">
          <v-vedio :path="videoList[videoIndex].path" />
        </div>
        <img
          @click="goForward"
          src="../assets/img2/video_arrow_right.png"
          style="cursor: pointer;"
        />
      </div>
      <div class="horizontal-box">
        <div
          v-for="(item, index) in videoList"
          :key="'media_' + index"
          :class="[
            videoIndex == index ? 'video-images-selected-box' : '',
            'video-image-box',
          ]"
        >
          <img style="width:100%" :src="item.imgPath" />
          <img
            v-if="videoIndex != index"
            class="play-image"
            src="../assets/img2/media_play_small.png"
          />
        </div>
      </div>
    </div>
    <div style="text-align:center">
      <img style="width:100%" src="../assets/img2/aidtools_process.png" />
    </div>
    <!-- <div class="middle">
      <div>
        <img
          style="cursor: pointer;"
          class="toShop"
          @click="
            goUrl(
              'https://item.taobao.com/item.htm?spm=a1z10.1-c-s.w5003-23287722221.1.5d9e1c81nwNMlD&ft=t&id=631176238901&scene=taobao_shop',
              'outer'
            )
          "
          src="../assets/img2/t2_2x.png"
        />
        <img id="pro" src="../assets/img2/t3_2x.png" />
      </div>
      <img id="pro2" src="../assets/img2/t4_2x.png" />
    </div>
    <img style="margin-top:80px;" src="../assets/img2/t5_2x.png" />
    <div class="middle">
      <div>
        <img id="dog1" src="../assets/img2/t6_2x.png" />
        <img id="dog2" src="../assets/img2/t7_2x.png" />
      </div>
      <img id="dog3" src="../assets/img2/t8_2x.png" />
    </div> -->
  </div>
</template>
<script>
import VHeader from "../components/Header.vue";
import VVedio from "../components/Vedio.vue";
export default {
  name: "AidTools",
  components: {
    VHeader,
    VVedio,
  },
  data() {
    return {
      selectIndex: -1,
      list: [
        "近8亿份独家诊断报告，包含车辆维保档案和社会修理厂诊断报告中提取的历史里程数据，通过智能AI分析判断车辆是否为改表车。",
        "基于8亿份独家诊断报告 中提取的历史故障数据 并整合多家数据渠道的 维保、保险理赔等多重 数据，加入智能AI分析 判断是否为事故车",
        "具备元征X431全车型全系统的诊断仪维修功能，读码、读数据流、读冻结帧，偶发故障码，一键清码。",
        "基于8亿份独家诊断报告中提取的历史故障数据。",
        "一键自动读取变速箱里程数据,发现潜在改表风险。",
        "一键自动读取变速箱里程，ABS防抱死系统，ECM发动机系统，IC仪表盘，SAS安全气囊系统等电控系统的里程数据。",
        "对比多个电控系统的车架号（VIN码）以及历史ECU数据判断车辆是否改装或更换重要零部件。",
        "上传行驶证一键查询车辆的维修、保养记录，包括车辆信息、维保时间、部位，集合多家渠道进行数据整合，性价比高，多渠道，查的率高。",
        "上传行驶证一键查询出险信息，车辆信息、出险记录、维修部位、金额、过户次数信息等一目了然，集合银保信数据与多家渠道整合，性价比高，查的率高。",
        "查询该车况及市场的价格作为参考。",
        "判断尾气排放是否符合国家标准。",
        "对车辆进行可信赖的认证检测，采用大数据人工智能检测技术，符合国家检测标准；全流程检测包括OBD检测、车辆点检等...通过全方位全生命周期的车况检测生成一份完整的可信赖报告。",
        "查询车辆的配置信息。",
        "查询车辆的排放是否符合迁。",
        "查询车辆违章信息。",
      ],
      videoList: [
        {
          path: "https://mrdata-adplatform.mingruidata.com/media/11.mp4",
          imgPath: require("../assets/img2/media_4.jpg"),
        },
        {
          path: "https://mrdata-adplatform.mingruidata.com/media/12.mp4",
          imgPath: require("../assets/img2/media_1.jpg"),
        },
        {
          path: "https://mrdata-adplatform.mingruidata.com/media/13.mp4",
          imgPath: require("../assets/img2/media_2.jpg"),
        },
        {
          path: "https://mrdata-adplatform.mingruidata.com/media/14.mp4",
          imgPath: require("../assets/img2/media_3.jpg"),
        },
      ],
      videoIndex: 0,
      urlList: [
        "https://detail.tmall.com/item.htm?id=655784337926&rn=4e0235601662cc558b2fb6f2c83086bf&spm=a1z10.3-b-s.w4011-24249604535.12.62275720YpUpyj",
        "https://detail.tmall.com/item.htm?id=655791193174&rn=4e0235601662cc558b2fb6f2c83086bfspm=a1z10.3-b-s.w4011-24249604535.18.62275720YpUpyj",
        "https://detail.tmall.com/item.htm?id=656168670477&rn=4e0235601662cc558b2fb6f2c83086bf&spm=a1z10.3-b-s.w4011-24249604535.24.62275720YpUpyj",
        "https://detail.tmall.com/item.htm?id=673833096602&rn=4e0235601662cc558b2fb6f2c83086bf&spm=a1z10.3-b-s.w4011-24249604535.36.62275720YpUpyj",
        "https://detail.tmall.com/item.htm?id=655791193174&rn=4e0235601662cc558b2fb6f2c83086bfspm=a1z10.3-b-s.w4011-24249604535.18.62275720YpUpyj",
      ],
    };
  },
  mounted() {
    const that = this;
    if (document.getElementById(that.$route.query.hashId)) {
      document
        .getElementById(that.$route.query.hashId)
        .scrollIntoView({ block: "center" });
      console.log("进入当前页面");
      that.$forceUpdate();
    }
    setTimeout(() => {
      if (document.getElementById(that.$route.query.hashId)) {
        document
          .getElementById(that.$route.query.hashId)
          .scrollIntoView({ block: "center" });
        that.$forceUpdate();
      }
    }, 600);
  },
  methods: {
    goUrl(url, type) {
      switch (type) {
        case "inner":
          this.$router.push({ path: url });
          break;
        case "outer":
          window.open(url);
          break;
      }
    },
    mouseover(index) {
      this.selectIndex = index;
    },
    goForward() {
      if (this.videoIndex > 2) {
        this.videoIndex = 0;
      } else {
        this.videoIndex++;
      }
      this.$forceUpdate();
    },
    goBack() {
      if (this.videoIndex < 1) {
        this.videoIndex = 3;
      } else {
        this.videoIndex--;
      }
      this.$forceUpdate();
    },
    goWeb(index) {
      window.open(this.urlList[index]);
    },
  },
};
</script>
<style lang="less" scoped>
div.aidtools_wrapper {
  position: relative;
  min-width: 1420px;
  width: 100%;
  background: #f8f8f7;
  > img {
    display: block;
    width: 100%;
  }
  > img.toShop {
    cursor: pointer;
  }
  > div.middle {
    position: relative;
    width: 1478px;
    margin: 0 auto;
    margin-top: 80px;
    > div {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      > img {
        display: block;
        width: 700px;
      }
    }
    > img {
      width: 100%;
      display: block;
      margin-top: 60px;
    }
  }
}
.product-box {
  background-image: url("../assets/img2/aidtools_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  //height: 3500px;
  box-sizing: border-box;
  text-align: center;
  margin-top: 50px;
  // padding-bottom: 320px;
  height: 4775px;

  img {
    display: block;
    margin: 0 auto;
    cursor: pointer;
  }
  > img:nth-last-child(n + 2) {
    width: 100%;
  }
  // > img:nth-child(2) {
  //   margin-top: 116px;
  // }
  // > img:nth-child(3) {
  //   margin-top: 50px;
  // }
  // > img:nth-child(4) {
  //   margin-top: 50px;
  // }
  // > img:nth-child(5) {
  //   margin-top: 140px;
  // }
  // > img:nth-child(6) {
  //   margin-top: 50px;
  // }
  > img:last-child {
    height: 136px;
  }
}
.video-box {
  width: 100%;
  background: #0d43a5;
  height: 1232px;
  text-align: center;
  padding-top: 110px;
  box-sizing: border-box;
}
.flex-layout {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 68px;
}
.video-image-box {
  width: 424px;
  margin: 0 auto;
  display: inline-block;
  position: relative;
}
.video-images-selected-box {
  width: 520px !important;
}
.play-image {
  width: 114px;
  position: absolute;
  top: calc(50% - 57px);
  left: calc(50% - 57px);
}
.horizontal-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 40px 0px 40px 0px;
  // margin-right: 60px;
  div {
    // margin-left: 60px;
  }
}
.introduce-box {
  text-align: center;
  margin-top: 120px;
  img {
    width: 1267px;
  }
}
.history-box {
  text-align: center;
  img {
    width: 1204px;
    margin-top: 60px;
  }
}
.padding-top-80 {
  padding-top: 150px;
}
.menu-box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1142px;
  margin: 0 auto;
  margin-top: -228px;
  margin-bottom: 120px;
  img {
    width: 228px;
    cursor: pointer;
    display: block;
  }
}
.menu-pop-box {
  width: 228px;
  height: 228px;
  padding: 20px 16px;
  box-sizing: border-box;
  position: absolute;
  color: #494949;
  background: white;
  font-size: 16px;
  line-height: 24px;
  top: 0;
  left: 0;
  z-index: 100;
}
.vedio-box {
  width: 1200px;
  height: 640px;
  margin: 0px 60px;
  display: inline-block;
}
.produce-txt-layout {
  margin-top: 120px;
  img {
    display: block;
    margin: 0 auto;
    height: 136px;
  }
}
</style>
